import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeleteCompanyBranchAdditionalDocumentProps {
  branchId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteCompanyBranchAdditionalDocument = ({
  branchId,
  onSuccess,
  onError,
}: UseDeleteCompanyBranchAdditionalDocumentProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteCompanyBranchAdditionalDocument'],
    mutationFn: (id: string) => {
      const payload = {
        company_branch: {
          additional_documents_attachments_attributes: [
            {
              id,
              _destroy: true,
            },
          ],
        },
      }

      return privateAxios.put(`/client/company_branches/${branchId}/update_additional_documents`, payload)
    },
    onSuccess,
    onError,
  })
}
